module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_vm._m(0), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                Hvordan vil din bundlinje se ud, hvis du kan opnå...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Flere timer hos kunderne\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm.customerHours.now) + " %\n                            ")])]), _vm._v(" "), (_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerHours.value),
      expression: "customerHours.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.customerHours.min,
      "max": _vm.customerHours.max
    },
    domProps: {
      "value": (_vm.customerHours.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.customerHours, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                +\n                                " + _vm._s(_vm.customerHours.value) + "\n                                " + _vm._s(_vm.customerHours.label) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "result"
  }, [(_vm.customerHours.value != _vm.customerHours.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.customerHoursTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]) : _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Timer hos kunderne kan ikke udregnes. Tjek, at du har angivet hvilke medarbejdere, der skal tages med i denne udregning.\n                        ")]), _vm._v(" "), (_vm.customerHours.value != _vm.customerHours.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at svendene i gennemsnit bruger "), _c('b', [_vm._v(_vm._s(Number(_vm.customerHours.now) + Number(_vm.customerHours.value)) + "%")]), _vm._v(" af deres tid hos kunderne\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Meromsætning pr. opgave\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm._f("currency")(_vm.data.revenue.avg_per_project)) + " pr. opgave\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectRevenue.value),
      expression: "projectRevenue.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.projectRevenue.min,
      "max": _vm.projectRevenue.max
    },
    domProps: {
      "value": (_vm.projectRevenue.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.projectRevenue, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                +\n                                " + _vm._s(_vm.projectRevenue.value) + "\n                                " + _vm._s(_vm.projectRevenue.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.projectRevenueTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at den gennemsnitlige pris pr. opgave øges med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.projectRevenueTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Besparelse på vareforbrug\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm._f("currency")(_vm.data.materials.total / _vm.data.revenue.total_projects)) + " pr. opgave\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialsUsage.value),
      expression: "materialsUsage.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.materialsUsage.min,
      "max": _vm.materialsUsage.max
    },
    domProps: {
      "value": (_vm.materialsUsage.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.materialsUsage, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                " + _vm._s(_vm.materialsUsage.value) + "\n                                " + _vm._s(_vm.materialsUsage.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.materialsUsageTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at den gennemsnitlige udgift til vareforbrug pr. opgave skal nedjusteres med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.materialsUsageTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            En forøgelse af mindste DG\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                Gns. DG pr. opgave i dag: " + _vm._s(_vm.data.coverage.average_percent) + "%\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coveragePercent.value),
      expression: "coveragePercent.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.coveragePercent.min,
      "max": _vm.coveragePercent.max
    },
    domProps: {
      "value": (_vm.coveragePercent.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.coveragePercent, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                " + _vm._s(_vm.coveragePercent.value) + "\n                                " + _vm._s(_vm.coveragePercent.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.coveragePercentTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen viser hvad du kan opnå, hvis du kan forbedre DG på alle opgaver til minimum "), _c('b', [_vm._v(_vm._s(_vm.coveragePercent.value) + "%")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('div', {
    staticClass: "today"
  }, [_vm._v("\n                    EBITDA i dag\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.ebitda)) + "\n                    ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "potential"
  }, [_vm._v("\n                    Potentielt fremtidigt EBITDA\n                    "), (_vm.totalPotential != _vm.ebitda) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totalPotential)) + "\n                    ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        -\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  })])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Hvad kan give effekt "), _c('u', [_vm._v("direkte")]), _vm._v(" på bundlinjen?\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "far fa-arrow-right"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fe26433", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe26433"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/potential.vue
// module id = 794
// module chunks = 0